export default {
  title: 'Shipping details',
  buttons: {
    save: 'Save',
  },
};
